<template>
  <div class="mainBox" :min-height="mainBoxHeight">
    <router-link :to="'/pageOneList?id='+paperId" style="text-decoration: none; float: left;">
    <div class="el-page-header__left" style="width:60px;">
      <i class="el-icon-back"></i>
    <div class="el-page-header__title">返回</div></div>
    </router-link>
    <span class="el-page-header__content" style="top: -0px;position: relative;font-size:14px;color: rgb(96, 98, 102);">详情页</span>
    <el-button v-if="!record.isConfirm||false"
    @click.stop="handel_Det_Paper"
    type="danger"
    icon="el-icon-delete"
    style="float: right; padding: 5px 10px;top:-1px;left:-4px;z-index:99;position: relative;"
    size="mini"
    round
    >删除</el-button>
    <!-- <el-page-header @back="goBack" content=""> </el-page-header> -->
    <el-alert v-if="!record.isConfirm" title="提醒：若最终完成，请至页底点击确认核报！" type="warning"> </el-alert>
    <el-form style="display: block !important;width: 100%!important;">
      <div style="text-align:left;padding:10px;color:red;border-bottom-style: double;">填报编号：{{record.recordId}}
         <el-badge @click.native="record.isConfirm?null:submitPaper" :type="record.isConfirm?'success':'info'"  :value="record.isConfirm?'√已核报':'待核报'" style="display: block;top:4px;left:-0px;float:right;">
    </el-badge>   
      </div>
     <el-row
        style="padding:6px 10px;"  :gutter="24"
      >
        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
           <span class="paperItemTitle">填报标题:</span>
           <div class="paperItemValue">&nbsp;{{record.title}}</div>
           <span class="paperItemTitle">填报人:</span>
           <div class="paperItemValue">&nbsp;{{record.fillBy}}</div>
           <span class="paperItemTitle">填报时间:</span>
           <div class="paperItemValue">&nbsp;{{record.createTime}}</div>
        </el-col>
      </el-row>
     
      <el-row
        :gutter="24"
      >
        <el-col v-for="(item, index) in collectionItem" v-bind:key="index" :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <el-form-item v-if="item.groupTitle==''" :label="item.itemTitle+'：'">
            <!-- {{item.itemTitle}} -->
            <el-input v-model="record[item.itemStore]" :placeholder="item.placeholder"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col v-for="(item, index) in collectionGroupItem" v-bind:key="index"   :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
          <br />
          <!-- 表头 -->
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span style="font-weight: bold;">{{++index+"."+item.groupTitle}}</span>
              <el-button v-if="!record.isConfirm"
                @click="typeIn(item.items)"
                type="primary"
                icon="el-icon-edit"
                style="float: right; padding: 7px 8px"
                circle
                ></el-button
              >
            </div>
            <!-- 表体 -->
            <div v-for="(item, index) in item.items" v-bind:key="index"  class="text item">
              <span class="paperItemTitle">{{ item.itemTitle +":"}}</span>
              <div class="paperItemValue">&nbsp;{{record[item.itemStore]}}</div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <!-- 确认核报 -->
    <div style="text-align: center">
      <el-button
      v-if="!record.isConfirm"
        @click="submitPaper"
        type="primary"
        icon="el-icon-edit"
        round
        style="width: 300px"
        >确认核报</el-button
      >
    </div>
    <br />
    <br />
    <br />
    <!-- 弹窗 -->
    <el-dialog
      title="填写内容"
      :visible.sync="dialogVisible"
      width="90%"
      style="max-width:530px;margin:auto;"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form style="display: block !important;width: 100%!important;">
         <el-row
        :gutter="0"
         v-for="(item, index) in tempItems" v-bind:key="index" 
      >
        <el-alert v-if="index==0" :title="item.groupTitle" type="success"  :closable="false"> </el-alert>
        <el-form-item :label="item.itemTitle+'：'">
          <el-input @click.native="item.inputType=='select'?openChoose(item,$event):null" v-model="item.userAnswer" :placeholder="item.placeholder" :clearable="true"></el-input>
        </el-form-item>
         </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitItems"
          >确 定</el-button
        >
      </span>
    </el-dialog>

      <!-- 弹窗 -->
    <el-dialog
      title="请选择:"
      :visible.sync="dialogSelectVisible"
      width="90%"
      style="max-width:530px;margin:auto;"
      :before-close="handleClose"
    >
      <el-form style="display: block !important;width: 100%!important;overflow:auto;">
         <span  style="dispaly:block;overflow:auto;"
        
         v-for="(item, index) in selectList.list" v-bind:key="index" 
      >
        <!-- <el-alert v-if="index==0" :title="item.groupTitle" type="success"  :closable="false"> </el-alert> -->
        <!-- <el-form-item :label="item.itemTitle+'：'">
          <el-input v-model="item.userAnswer" :placeholder="item.placeholder" clearable="true"></el-input>
        </el-form-item> -->
        <div @click="choose(selectList,item)" > 【{{item}}】</div>
         </span>
      </el-form>
      <br/>
       <br/>
        <br/>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitItems"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
 
  </div>
</template>

 <script type="text/javascript">
      function aaa(){
  alert("sss");
}
    </script>

<script>
import Vue from 'vue'
import { Get_Paper_Record,Put_Paper_Item ,Put_Paper_Confirm,Det_Paper,
Get_Paper_allItem} from "@/api/pageOne/ApiIndex.js";



export default {
  data() {
    return {
      mainBoxHeight:200,
      activeNames: ["1"],
      dialogVisible: false,
      paperId:"",
      recordId:"",
      record:"",
      collectionItem:[],
      collectionGroupItem:[],
      tempItems:[],
      allItems:[],
      paperAllItems:[],
      dialogSelectVisible:false,
      selectList:{},
      
    };
  },
    created(){
     this.recordId = this.$route.query["id"].toString(); 
     this.paperId = this.$route.query["pid"].toString(); 
     this.handle_Get_Paper_Record();
     Get_Paper_allItem({ paperId: this.paperId}).then((response) => {
      if (response.data.code == 20000) {
        this.paperAllItems = response.data.data;
      }
     });
  },
  methods: {
    // 未用
    goBack() {
      console.log("go back");
    },
    // 未用
    handleChange(val) {
      console.log(val);
    },
    // 取记录本身
    handle_Get_Paper_Record(){
      Get_Paper_Record({recordId:this.recordId})
        .then(response => {
          this.record = response.data.data[0];
          this.collectionItem = response.data.data2
          this.collectionItem.forEach(item => {
            item["items"] = response.data.data3.filter(item2 => item.groupTitle == item2.groupTitle)
          });
          this.collectionGroupItem = this.collectionItem
          // console.log(this.record)
        })
    },
    // 关闭弹窗
    handleClose(done) {
       done();
      // this.$confirm("确认关闭？")
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
    },
    // 点击输入内容
    typeIn(items) {
      this.tempItems = items;
      this.tempItems.forEach(item=>{
        item.userAnswer = this.record[item.itemStore];
      })
      this.dialogVisible = true;
    },
    // 判断并提交内容
    submitItems(){
      var numReg = /^([0-9]*)+(\.[0-9]{1,2})?$/;
      var numRe = new RegExp(numReg)
      //if (!numRe.test(number)
      let nullValue = 0
      let errMessage = "";
      this.tempItems.forEach(item =>{
         if(item.userAnswer!=null) item.userAnswer =  item.userAnswer.trim();
        //判断是否填写了值
        if(item.userAnswer==null || item.userAnswer==""){
          nullValue ++
          if(errMessage.length==0)
          errMessage = "项目【"+item.itemTitle + "】未填写，请检查！";
        }else{
          //判断为可有.数字
          if(item.valueType=="int" && (!numRe.test(item.userAnswer))){
            if(errMessage.length==0)
            errMessage = "项目【"+item.itemTitle + "】应输入数字，请检查！";
          }
          //判断为省份列表指定汉子
          if(item.valueType=="province" && item.selectList.split(',').indexOf(item.userAnswer)<0){
             if(errMessage.length==0){
              var reg = new RegExp(",","g");//g,表示全部替换。
              let newMsg="【"+Vue.prototype.province.toString().replace(reg,'】<br/>【')+"】";
              errMessage = "<div style='max-height:420px;overflow-y:scroll;'>项目【"+item.itemTitle + "】请输入“【】”内汉字：<br/>"+newMsg+"<div>";
            }
          }
        }
      })
      if(nullValue>0){
         this.$alert(errMessage, "错误信息", { type: "error" });
         return
      }
      if(errMessage.length>0){
         this.$alert(errMessage, "错误信息", { type: "error", dangerouslyUseHTMLString:true,});
         return
      }

       let query = {
        recordId: this.recordId,
        data: this.tempItems,
      };
      Put_Paper_Item(query).then((response) => {
        if (response.data.code != 20000) {
          this.$alert(response.data.message, "错误信息", { type: "error" });
          this.dialogVisible = false;
          return;
        }
        this.handle_Get_Paper_Record();
        this.dialogVisible = false;
      });
    },
    // 确认核报
    submitPaper(){
      let nullValue = 0
      let errMessage = "";
      this.paperAllItems.forEach((item) =>{
        if(this.record[item.itemStore]==null || this.record[item.itemStore]==""){
          nullValue++ ;
          if(errMessage.length==0)
            errMessage = "项目【"+item.itemTitle + "】未填写，请检查！";
          }
      })
      if(errMessage.length>0){
         this.$alert(errMessage, "错误信息", { type: "error", dangerouslyUseHTMLString:true,});
         return
      }
      this.$confirm("确认核报吗？提交后不能再修改！")
        .then((_) => {
          Put_Paper_Confirm({recordId:this.recordId})
          .then(response =>{
            if (response.data.code != 20000) {
              this.$alert(response.data.message, "错误信息", { type: "error" });
              this.dialogVisible = false;
              return;
            }
            this.$message({message: "提交成功！",type: "success"});
            this.handle_Get_Paper_Record();
            this.dialogVisible = false;
          })
          done();
        })
        .catch((_) => {});
    },
    // 删除记录
    handel_Det_Paper(){
      this.$confirm("确认删除吗？删除后不可恢复！")
        .then((_) => {
           Det_Paper({recordId:this.recordId})
          .then(response =>{
            if (response.data.code != 20000) {
              this.$alert(response.data.message, "错误信息", { type: "error" });
              this.dialogVisible = false;
              return;
            }
            this.$message({message: "删除成功！",type: "success"});
            this.$router.push({ path: '/pageOneList?id=' + this.paperId })
          })
          done();
        })
        .catch((_) => {});
     
    },
    openChoose(item,event){
      //console.log("ssss")
      event.srcElement.blur();
      var list = item.selectList.split(",");
      this.selectList = {
        item:item,
        list:list,
      }
      this.dialogSelectVisible = true;
    },
    choose(selectList,item){
      selectList.item.userAnswer = item;
      this.dialogSelectVisible = false;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
//<!--3.1、样式区-->
<style type="text/css" scoped>
.mainBox {
  max-width: 900px;
  margin: 0px auto 10px auto;
  background-color: #fffdf7;
  border-style: dotted;
  border-width: thin;
  padding: 10px 10px;
  border-color: gainsboro;
  border-radius: 10px;
}
.el-message-box{
   max-width: 130px !important;
   width:300px !important;
}
.paperItemValue {
  word-break: break-all;
  font-size: 14px;
  
  /* color: rgb(162, 152, 29); */
  color:#f56c6c;
  border-color: rgb(235, 238, 245);
  border-radius: 6px;
  /* border-style: solid; */
  background-color: #fbfbfb;
  padding: 7px;
  min-height: 20px;
  border-width: 1px;
}
.paperItemTitle {
  /* font-weight: bold; */
  font-size: 14px;
  color: rgb(96, 98, 102);
  /* color: #055cb6; */
  padding: 4px 0px;
  display: inline-block;
}
/**控制本页边界 */
.el-form-item {
  margin-bottom: 10px !important;
}
.el-table .cell {
  line-height: 14px !important;
}
.el-divider--horizontal {
  margin: 10px 0 !important;
}
.el-dialog__body {
  padding: 0px 20px 20px 20px !important;
}
/**解决form无高度问题 */
.el-form {
  display: inline-block !important;
}
.el-table--mini th,
.el-table--mini td {
  padding: 0px !important;
}
.el-table--small th,
.el-table--small td {
  padding: 4px !important;
}
.el-table .cell {
  line-height: 16px !important;
}
.el-divider--horizontal {
  margin: 12px 0px !important;
}
.el-card {
  border-radius: 16px !important;
  /* //background-color: #fdfbf8 !important; */
  box-shadow: 1px 1px 2px #888888;
}
.el-dialog {
  border-radius: 16px !important;
}
.light:hover {
  color: red !important;
}
.el-badge__content.is-fixed {
  z-index: 20 !important;
}
</style>

<style type="text/css">
.el-dialog {
  border-radius: 12px !important;
}
.el-message-box{
   max-width: 330px !important;
   /* width:300px !important; */
}
.el-dialog__body {
  padding: 0px 20px !important;
}
.el-form-item__label{
  font-weight:bold ; 
}
</style>


// WEBPACK FOOTER //
// src/api/pageOne/pageOne.vue